import React, { useState } from "react"
import { useDispatch, useSelector } from 'react-redux';
import { DropDownField, CalendarField, Button } from "../../../helpers"
import { raiseToast } from "../../../services/redux/reducers/toast/toast"
import moment from "moment"
import Loading from "../../../common/Loading";

import { updatePettyCashSecondayPaymentStatus } from "../../../services/api/pettyCash"
import { updatePettyCashData } from "../../../services/redux/reducers/pettycash/pettycash";


const SecondayPaymentStatus = (props) => {
    const { selectedPettyCashId } = props

    const pettyCashData = useSelector(state => state.pettyCash.pettyCashData)

    const [paymentStatus, setPaymentStatus] = useState(true)  // Default to 'Paid'
    const [paymentDate, setPaymentDate] = useState(new Date())
    const [isLoading, setIsLoading] = useState(false)

    const dispatch = useDispatch()

    const paymentOptions = [
        {label: 'PAID', value: true},
        {label: 'UNPAID', value: false}
    ]

    const handleSecondayPaymentSave = async () => {
        if (paymentStatus && paymentDate) {
            const data = {
                pettyCashId: selectedPettyCashId,
                secondaryPaymentStatus : paymentStatus,
                secondaryPaymentDate : paymentDate
            }

            if (window.confirm("Once saved, the status cannot be modified. Do you wish to proceed?")) {
                setIsLoading(true)
                const secondaryPaymentStatusRes = await updatePettyCashSecondayPaymentStatus(data)
                if (!secondaryPaymentStatusRes.failure) {
                    const updatedPettyCashData = pettyCashData.map(eachpettycash => {
                        if (eachpettycash.pettyCashId === selectedPettyCashId) {
                            return {
                                ...eachpettycash,
                                secondaryPaymentStatus: paymentStatus,
                                secondaryPaymentDate: paymentDate
                            }
                        }
                        return eachpettycash
                    })
                    dispatch(updatePettyCashData(updatedPettyCashData))
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'success', summary: "Secondary Payment Status", detail: 'Payment status saved successfully', life: 3000 }))
                } else {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'error', summary: "Secondary Payment Status", detail: secondaryPaymentStatusRes.data.error, life: 3000 }))
                }
            }
        } else {
            return dispatch(raiseToast({ severity: 'warn', summary: "Secondary Payment Status", detail: 'Please make changes in status and date.', life: 3000 }))
        }
    }

    return (
        <div className="p-card mb-0">
            <Loading visible={isLoading} />
            <div className="grid">
                <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                    <DropDownField
                        labelText="Payment Status"
                        options={paymentOptions}
                        optionLabel="label"
                        value={paymentStatus}
                        onChange={(e) => setPaymentStatus(e.target.value)}
                        required
                    />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                    <CalendarField
                        labelText="Payment Date"
                        maxDate={new Date()}
                        value={paymentDate}
                        onChange={(e) => setPaymentDate(e.target.value)}
                        required
                    />
                </div>
            </div>
            <div className="flex justify-content-end mt-2">
                <Button label="save" onClick={handleSecondayPaymentSave} />
            </div>
        </div>
    )
}

export default SecondayPaymentStatus
